import type { PropsWithChildren } from 'react';
import type { ModalProps } from '@launchpad-ui/components';
import { Modal, ModalOverlay } from '@launchpad-ui/components';
import clsx from 'clsx';

import styles from './SaveChangesModal.module.css';

export function SaveChangesModal({ children, className, ...props }: PropsWithChildren<ModalProps>) {
  return (
    <ModalOverlay>
      <Modal className={clsx(styles.modal, className)} data-test-id="save-changes-confirm-modal" {...props}>
        {children}
      </Modal>
    </ModalOverlay>
  );
}
